import { isHostz, isAlvarezArguellez } from "./hotelConditions";

const showHouseKeeping = (hotelId) => {

    const noShowHotels = [
        // "511e8df9-672d-42b1-9711-d82beb7baf64",//DEV

        "3b70cefa-4202-48c5-aa21-cdbaef82f182",//CASTAGNO
        "9324d1b3-c49b-45fd-8a4e-d48bb5c48516",//FERIEN
        "44dc5e46-b6ca-43c9-8ec7-e4a4b5ebb66b",//KAlMSTAY
        "eb618aea-3d7b-4496-986a-b7f034554ac8",//KALM STAY SMART STUDIOS
        //APART YOU
        "b4889f16-8dc7-40f5-814b-5a1ed90d3947",
        "8b62cf50-d136-402b-abbc-81fb0b3ac162",
        "7f1d1e0b-acea-4c79-b442-f9dc557c4956",
        "2c31590f-739c-46b3-aca6-665e83a518ea",
        "bd8df831-ce3d-4596-ad10-3bbc188ded7d",
        "8fcf8b78-ed33-4575-b00a-4c8be2886ce0",
        "54aa721b-8f04-495b-923c-07d90e08fb92",
        "fea1efb3-9d97-4374-ab72-109bda0a9819",
        "4c126315-cf81-4e93-93fb-57ca1b07d220",
        "de6a6244-3a0c-44fb-b1e8-53f38d94019a",
        "e2ba6052-9f7f-4213-93a7-094317fc722f",
        "cf9b040e-bcf6-4d55-adbb-9fc705183e9c",
        "58e23f10-b106-483d-830e-5414ce661bed",
        "c9d798bc-2fb0-482e-8b3a-4577b94e788f",
        "72501582-74d3-4308-b139-2ba80beded69",
        "bf91530e-77a0-42a5-8d77-f487fb3245ad",
        //FIN DE APARTYOU
        "1de880e5-bfb6-4518-bd1b-095443bbc58b",  // COSTA GALANA
        "c07d2d8a-9db1-412c-b24d-c0fcc3c5e7a0",  // BELAIR
        "c0bb7b5c-cd44-4288-98f1-4868ea4e5c11",  // COMAHUE
        "f33a83b9-6284-46e6-8469-b5b17de2c9ba",  // BRIZO NEUQUEN

        "d55fa17e-d630-49ea-af48-4b2d2d9e557c", // OFFGRID KLAUDIA
        "49e0c3db-e283-4c50-afc3-f16ab364733c", // OFFGRID PUNNU
        "23a7aaa1-f022-477a-abc6-c6f0d0e92dbf", // OFFGRID LISA
        "9d20c705-e487-4fa1-bce9-78d67f551b9a", // OFFGRID MAX
        "5f5da43a-39d9-4ef7-9298-976cad051f54",  // OFFGRID JOHANNA
        "7ef6b919-e25f-4153-9fb3-8e7939ff7252",  // OFFGRID CLIVE
        "8d03f1be-8796-4a8b-9263-ff9e7b9584eb",  // OFFGRID QUINTON
        "6bb9ef92-5706-4fbf-a73b-913ee250b87e",  // OFFGRID RENATE
        "bad68038-0134-4a46-8f97-e00ed4d2d6e4",  // OFFGRID GUNTER
        "04f8680c-1013-4915-8f20-b65166c3e5f6",  // OFFGRID CARL
        "1452a98d-66a2-4214-bf48-371e70245417",  // OFFGRID MARIUS

        // "d4676e50-71ed-4c01-bcdf-84b2b55b1890"  // HOSTZ - BLACKSUMMIT
    ];

    return !noShowHotels.includes(hotelId) && !isHostz(hotelId) && !isAlvarezArguellez(hotelId);
}

export default showHouseKeeping;
